import { VerificationConfigurationState } from "@idw-types/state";
import { VerificationConfigActionTypes, VerificationConfigurationActions } from "../actions/verification-configuration-actions";
import { RootActions, RootActionTypes } from "../actions/root-actions";

export const initialVerificationConfigurationState: VerificationConfigurationState = {
	config: null,
	loading: false,
	loadingFailed: false,
};

export const verificationConfigurationReducer = (
	state: VerificationConfigurationState = initialVerificationConfigurationState,
	action: VerificationConfigurationActions | RootActions
) => {
	switch (action.type) {
		case VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION:
			return {
				...state,
				config: action.payload.config
			};
		case VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING:
			return {
				...state,
				loading: action.payload.loading
			};
		case VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING_FAILED:
			return {
				loading: false,
				loadingFailed: true,
				config: action.payload.clearConfigOnError ? null : state.config
			};
		case VerificationConfigActionTypes.SET_VERIFY_TOKEN:
			return {
				...state,
				config: {
					...state.config,
					verifyToken: action.payload.token
				}
			};
		case RootActionTypes.RESET_STATE:
			return { ...initialVerificationConfigurationState };
		default:
			return state;
	}
};